const cz = {
  "nav": [
    "Ceník",
    "Reference",
    "FAQ",
    "Kontakt"
  ],
  "navCta": "Získat návrh zdarma",
  "heroBadge": "🔥 Akce — 50% sleva pouze do konce měsíce",
  "heroTitle": "Děláme weby navržené pro získávání nových zákazníků",
  "heroSub": "Moderní design + SEO, aby vás zákazníci našli na Googlu.\nHotovo už od 3 dnů.",
  "heroBenefits": [
    "Design navržený tak, aby návštěvníka proměnil v poptávku",
    "Prvotřídní rychlost a bezchybné zobrazení na mobilech",
    "Kompletní nastavení: Kontaktní formuláře, mapy a propojení",
    "Pokročilé SEO optimalizace, aby vás klienti našli na Google",
    "Bleskové dodání od 3 dnů bez zbytečného natahování"
  ],
  "heroCta": "Chci nezávazný návrh webu zdarma",
  "navOrder": "Poptávka",
  "heroMicro": "první koncept do 24 hodin · zcela bez závazků · ukážeme vám, jak prodávat víc",
  "marketTag": "🌍 Weby pro firmy v Česku · na Slovensku · v Evropě",
  "marketTagShort": "🌍 Weby pro firmy v CZ · na SK · v EU",
  "problemLabel": "Kde ztrácíte peníze?",
  "problemTitle": "Proč většina firemních webů jen sedí na internetu a nevydělá ani korunu?",
  "problemPoints": [
    "Máte starý web, který místo lákání klientů vaši firmu reprezentuje špatně",
    "Web se na mobilu rozsype, seká nebo se načítá příliš dlouho",
    "Lidé vás na Google vůbec nemohou najít — hovory a maily chodí vaší konkurenci",
    "Web vypadá jako ze starého století a zákazníci vám kvůli tomu nedůvěřují",
    "Agentury od vás chtějí tisíce korun předem bez jakékoli garance výsledku"
  ],
  "problemClose": "Výsledek: Vaše konkurence roste, zatímco vy přicházíte o desítky poptávek měsíčně.",
  "agitTitle": "Každý den se slabým webem darujete zákazníky konkurenci",
  "agitText": "Pěkný web nestačí. Pokud vám web nepřináší telefonáty a objednávky, jsou to vyhozené peníze. My stavíme weby kolem potřeb vašich budoucích klientů.",
  "solutionLabel": "Náš proces",
  "solutionTitle": "Odesláním formuláře k novým zákazníkům od 3 dnů",
  "solutionSteps": [
    {
      "num": "01",
      "title": "Nezávazná poptávka",
      "desc": "Zvolíte si cíl, napíšete nám o vašem podnikání a odešlete rychlý formulář."
    },
    {
      "num": "02",
      "title": "Koncept do 24 hodin",
      "desc": "Zcela zdarma vám vypracujeme úvodní vizuální a strategický návrh řešení."
    },
    {
      "num": "03",
      "title": "Vyladění detailů",
      "desc": "Pokud se vám směřování líbí, doladíme texty, strukturu a funkce přesně podle vás."
    },
    {
      "num": "04",
      "title": "Spuštění od 3 dnů",
      "desc": "Web nasadíme na vaši doménu, nastavíme přehled, kolik lidí váš web navštívilo, a předáme vám všechny přístupy."
    }
  ],
  "pricingLabel": "Transparentní ceny",
  "pricingTitle": "Investujte do řešení, které se vám rychle vrátí",
  "pricingNote": "Žádné skryté poplatky. Vyberte si balíček, který nejlépe odpovídá vašim aktuálním cílům.",
  "orderBtn": "Zvolit tento balíček a získat návrh →",
  "cards": [
    {
      "tag": "Starter",
      "badge": null,
      "name": "Webová vizitka",
      "price": "3 725 Kč",
      "old": "běžně 15 000 Kč",
      "forWhom": "Ideální pro živnostníky, řemeslníky a lokální služby",
      "features": [
        "Prodejní design na jedné přehledné straně",
        "100% optimalizace pro chytré telefony a tablety",
        "Propojení na přímý hovor, e-mail a interaktivní mapu",
        "Propojení na WhatsApp a Messenger pro okamžitý kontakt",
        "Základní nastavení SEO pro vyhledávání v okolí",
        "Příprava na legislativu a GDPR (cookies lišta)",
        "BONUS: Nastavení / audit Google Business profilu",
        "Kompletní odevzdání od 3 pracovních dnů"
      ],
      "featured": false,
      "dark": false
    },
    {
      "tag": "Growth",
      "badge": "Nejpopulárnější",
      "name": "Byznys web na poptávky",
      "price": "12 500 Kč",
      "old": "běžně 25 000 Kč",
      "forWhom": "Nejlepší poměr cena/výsledek pro stabilní firmy na trhu",
      "features": [
        "Vše z balíčku Starter +",
        "Až 5 kompletně navržených podstránek (Služby, O nás...)",
        "Přehledná galerie projektů a sekce referencí",
        "Zjistíme, co vaši zákazníci píšou do Googlu, a nastavíme web tak, abyste se jim ukázali",
        "Uvidíte, kolik lidí vám z webu zavolalo nebo napsalo",
        "Kompletní odevzdání do 5 pracovních dnů"
      ],
      "featured": true,
      "dark": false
    },
    {
      "tag": "Performance",
      "badge": "Prodejní stroj",
      "name": "Kompletní E-shop",
      "price": "25 000 Kč",
      "old": "standardně 50 000 Kč",
      "forWhom": "Pro ambiciózní projekty připravené prodávat produkty online",
      "features": [
        "Vše z balíčku Byznys +",
        "Plně funkční e-shop s kapacitou do 500 produktů",
        "Integrace ověřených platebních bran (karty, Apple Pay)",
        "Automatické generování faktur a propojení na sklad",
        "Přehledný systém pro správu objednávek a zákazníků",
        "Kompletní odevzdání do 14 pracovních dnů"
      ],
      "featured": false,
      "dark": true
    }
  ],
  "featuredBadge": "Doporučeno",
  "reviewsLabel": "Naše práce mluví za nás",
  "reviewsTitle": "Podívejte se na výsledek nedávného projektu",
  "riskTitle": "Spolupráce bez jakéhokoli rizika",
  "riskText": "Věříme své práci, proto neriskujete ani jednu korunu. První koncept připravíme na naše náklady. Vy se rozhodnete, zda budeme pokračovat.",
  "riskPoints": [
    "✓ Úvodní vizuální návrh máte do 24 hodin zcela ZDARMA",
    "✓ Nejprve podepíšeme smlouvu, zálohu platíte až když jste s konceptem na 100% spokojeni",
    "✓ Jasný plán a komunikace bez zbytečného technického žargonu",
    "✓ Žádné skryté poplatky ani vázanost"
  ],
  "finalCtaTitle": "Chcete web, který bude pro vaši firmu reálně vydělávat?",
  "finalCtaSub": "Nečekejte, až vás konkurence předběhne úplně. Vyplňte formulář a zítra máte na stole řešení.",
  "finalCtaBtn": "Získat nezávazný návrh řešení →",
  "stickyCtaBtn": "Chci nový web od 3 725 Kč →",
  "formLabel": "Rychlá poptávka",
  "formTitle": "Získejte profesionální návrh webu do 24 hodin zdarma",
  "formSub": "Napište nám základní detaily. Návrh je nezávazný — pokud se vám nebude líbit, nic neplatíte.",
  "fields": [
    {
      "key": "name",
      "label": "Vaše jméno a příjmení *",
      "type": "text",
      "placeholder": "např. Jan Novák"
    },
    {
      "key": "email",
      "label": "Kontaktní e-mail *",
      "type": "email",
      "placeholder": "jan@firma.cz"
    },
    {
      "key": "phone",
      "label": "Telefonní číslo *",
      "type": "tel",
      "placeholder": "+420 777 111 222"
    }
  ],
  "packageLabel": "Zvolený balíček *",
  "packagePlaceholder": "— Vyberte si startovací pozici —",
  "packages": [
    "Landing page — 3 725 Kč",
    "Byznys web na poptávky — 12 500 Kč",
    "Kompletní E-shop — 25 000 Kč"
  ],
  "intentNote": "Vyberte si balíček, který nejlépe odpovídá vašim aktuálním cílům.",
  "intentCards": [
    {
      "value": "Landing page — 3 725 Kč",
      "intent": "Chci jen moderní vizitku",
      "sub": "Potřebuji reprezentativní a rychlou stránku, aby mě klienti našli na internetu.",
      "price": "3 725 Kč",
      "badge": null
    },
    {
      "value": "Byznys web na poptávky — 12 500 Kč",
      "intent": "Chci stabilně získávat zákazníky",
      "sub": "Potřebuji řešení navržené pro generování poptávek, telefonátů a objednávek služeb.",
      "price": "12 500 Kč",
      "badge": "Nejlepší volba"
    },
    {
      "value": "Kompletní E-shop — 25 000 Kč",
      "intent": "Chci prodávat produkty online",
      "sub": "Hledám plnohodnotný, automatizovaný online obchod, který zvládne celý prodej za mě.",
      "price": "25 000 Kč",
      "badge": null
    }
  ],
  "messageLabel": "Řekněte nám něco o vašem podnikání (nepovinné)",
  "messagePlaceholder": "Čemu se věnujete? Co od nového webu očekáváte nejvíc?",
  "submitBtn": "Odeslat poptávku a získat návrh zdarma →",
  "submitting": "Připravuji data...",
  "successTitle": "Skvělé, Vaši poptávku jsme úspěšně přijali!",
  "successMsg": "Vaši poptávku jsme zaevidovali. Ihned se pouštíme do analýzy a do 24 hodin vás budeme kontaktovat s hotovým návrhem.",
  "newOrder": "Nová poptávka z webu",
  "errorMsg": "❌ Systému se nepodařilo odeslat formulář. Zkuste to znovu nebo nám zavolejte na číslo nahoře.",
  "footerRights": "© 2026 WebKlienti · Profesionální webdesign zaměřený na výsledky",
  "faqLabel": "Odpovídáme",
  "faqTitle": "Vše, co potřebujete vědět před startem",
  "faqItems": [
    {
      "q": "Kolik reálně trvá vytvoření webu?",
      "a": "Jsme rychlí, protože máme zaběhnutý proces. Jednostránkový web spustíme od 3 pracovních dnů, vícestránkový byznys web do 5 pracovních dnů a plnohodnotný e-shop do 14 dnů od schválení úvodního konceptu."
    },
    {
      "q": "Budu platit nějaké pravidelné měsíční poplatky?",
      "a": "Ne. U nás platíte pouze jednorázově za kompletní zhotovení webu. Web je po odevzdání 100% váš. Jediné roční náklady jsou za vaši doménu a webhosting (cca 500–800 Kč ročně), které platíte přímo poskytovateli hostingu — s jejich výběrem a nastavením vám kompletně pomůžeme."
    },
    {
      "q": "Jak probíhá platba a kdy posílám peníze?",
      "a": "Začátek je zcela bezpečný. Vyplníte formulář, my uděláme analýzu a do 24 hodin vám pošleme první vizuální koncept zdarma. Pokud řeknete 'ano, tohle se nám líbí', podepíšeme smlouvu a uhradíte 50% zálohu. Zbývajících 50% platíte až tehdy, když je web hotový, otestovaný a připravený ke spuštění."
    },
    {
      "q": "Proč jsou vaše ceny výrazně nižší než u klasických agentur?",
      "a": "Neplatíme drahé kanceláře v centru města, manažery ani sekretářky. Jsme efektivní tým vývojářů a designérů. Vyvinuli jsme vlastní optimalizované postupy, díky kterým dokážeme eliminovat zbytečné prostoje a dodat špičkový firemný web za zlomek běžné ceny."
    },
    {
      "q": "Co když nemám žádné texty ani profesionální fotografie?",
      "a": "Žádný problém, postaráme se o to. Na základě krátkého rozhovoru o vašem podnikání napíšeme konverzní texty za vás. Pokud nemáte vlastní fotky, vybereme licencované a vysoce profesionální snímky z prémiových fotobank, které dokonale sednou k vaší značce."
    },
    {
      "q": "Kdo bude vlastnit hotovou webovou stránku?",
      "a": "Vy. Na rozdíl od jiných firem, které vás uzamknou do vlastních platforem na měsíční pronájmy, od nás dostanete plné administrátorské přístupy. Web funguje nezávisle a můžete si s ním dělat cokoli."
    },
    {
      "q": "Co se stane, když se mi váš první návrh do 24 hodin nebude líbit?",
      "a": "Jednoduše nám řeknete, co máme změnit a my návrh upravíme. Pokud byste měli pocit, že jsme se úplně minuli vaší představě, spolupráci můžete bez jakýchkoli otázek a poplatků ukončit. Vzhledem k tomu, že jste před návrhem nic neplatili, neriskujete vůbec nic."
    }
  ],
  "guaranteeTitle": "Stoprocentní garance spokojenosti",
  "guaranteeText": "První reálný koncept vašeho webu vidíte dřív, než zaplatíte byť jen jedinou korunu.",
  "guaranteeBadges": [
  "✓ Strategická analýza trhu a návrh do 24 hodin",
  "✓ První koncept zcela zdarma a bez závazků",
  "✓ Žádné skryté poplatky ani vázanost"
  ],
  "cookieMsg": "Tento web používá technologie cookies k zajištění správné funkčnosti a měření návštěvnosti.",
  "cookieAccept": "Akceptovat vše",
  "cookieDecline": "Odmítnout",
  "privacyLink": "Zásady ochrany soukromí",
  "privacyTitle": "Zpracování osobních údajů",
  "privacyContent": "Provozovatel: WebKlienti, info@webklienti.com, +421 907 890 600\n\nJaké údaje sbíráme:\n• Jméno, příjmení, e-mail, telefonní číslo — výhradně při dobrovolném odeslání poptávkového formuláře.\n\nNa co je používáme:\nPříprava bezplatného návrhu, zpracování cenové nabídky, komunikace se zákazníkem a plnění smluvních závazků.\n\nDoba uchovávání:\nPo dobu trvání komunikace nebo smluvního vztahu a následně po dobu vyžadovanou platnými zákony.\n\nVaše práva:\nMáte plné právo na přístup ke svým údajům, jejich opravu, vymazání (právo na zapomnění) nebo omezení zpracování. Jakékoli žádosti posílejte na info@webklienti.com.\n\nAnalytika:\nPoužíváme anonymizovaný nástroj Google Analytics pro optimalizaci chodu webu a měření úspěšnosti reklamních kampaní.\n\nPlatné od: 1.1.2025",
  "statNote": "Každý projekt stavíme od první linie kódu pro maximální výkon a rychlost. Žádné pomalé, kupované šablony.",
  "seoTitle": "Tvorba webových stránek pro malé firmy od 3 725 Kč | WebKlienti",
  "seoDescription": "Vytvoříme vám web, díky kterému vás zákazníci najdou na Googlu. Hotovo už od 3 dnů, návrh do 24 hodin zdarma.",
  "seoUrl": "https://www.webklienti.com",
  "heroTag": "Výkonnostní webdesign pro malé a střední firmy",
  "heroCtaSec": "Zobrazit ceník ↓",
  "trustStrip": [
    "Přijímáme maximálně 2 nové projekty týdně pro udržení prémiové kvality",
    "Čistý kód optimalizovaný pro maximální rychlost",
    "Kompletní pokrytí pro CZ a SK trh",
    "Navrženo s jediným cílem: Proměňovat návštěvy v poptávky"
  ],
  "consentLabel": "Souhlasím se zpracováním osobních údajů za účelem vypracování nezávazné nabídky v souladu se",
  "consentLink": "Zásadami ochrany soukromí",
  "consentError": "Pro odeslání poptávky musíte potvrdit souhlas se zpracováním osobních údajů."
};

export default cz;
